import axios from 'axios';

const service = axios.create({
    baseURL: '/wms/api',
    timeout: 10000,
});

service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.code !== 200 && res.code !== 0) {
            console.error('API Error:', res.msg || 'Unknown error');
            return Promise.reject(new Error(res.msg || 'Error'));
        } else {
            return res.data;
        }
    },
    error => {
        console.error('Network Error:', error.message);
        return Promise.reject(error);
    }
);

export default service;